/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PBlast from "./.";
import * as GenericExceptions from "./../common/exceptions";
import * as PHeader from "./../common/models";
import * as PContact from "./../common/models";
export namespace TBlastService {
    export interface ISubmitBlastArgsArgs {
        request: PBlast.TSubmitBlastRequest;
    }
    export class SubmitBlastArgs {
        public request: PBlast.TSubmitBlastRequest;
        constructor(args: ISubmitBlastArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SubmitBlastArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SubmitBlastArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_1: PBlast.TSubmitBlastRequest = PBlast.TSubmitBlastRequest.read(input);
                            _args.request = value_1;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new SubmitBlastArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read SubmitBlastArgs from input");
            }
        }
    }
    export interface IIsBlastEligibleArgsArgs {
        header: PHeader.TAuthHeader;
        request: PBlast.TIsBlastEligibleRequest;
    }
    export class IsBlastEligibleArgs {
        public header: PHeader.TAuthHeader;
        public request: PBlast.TIsBlastEligibleRequest;
        constructor(args: IIsBlastEligibleArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("IsBlastEligibleArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): IsBlastEligibleArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_2: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_2;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_3: PBlast.TIsBlastEligibleRequest = PBlast.TIsBlastEligibleRequest.read(input);
                            _args.request = value_3;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new IsBlastEligibleArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read IsBlastEligibleArgs from input");
            }
        }
    }
    export interface IUpdateBlastStatusArgsArgs {
        header: PHeader.TAuthHeader;
        request: PBlast.TUpdateBlastStatusRequest;
    }
    export class UpdateBlastStatusArgs {
        public header: PHeader.TAuthHeader;
        public request: PBlast.TUpdateBlastStatusRequest;
        constructor(args: IUpdateBlastStatusArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateBlastStatusArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateBlastStatusArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_4: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_4;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_5: PBlast.TUpdateBlastStatusRequest = PBlast.TUpdateBlastStatusRequest.read(input);
                            _args.request = value_5;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateBlastStatusArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateBlastStatusArgs from input");
            }
        }
    }
    export interface IGetBlastInfoArgsArgs {
        request: PBlast.TGetBlastInfoRequest;
    }
    export class GetBlastInfoArgs {
        public request: PBlast.TGetBlastInfoRequest;
        constructor(args: IGetBlastInfoArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetBlastInfoArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetBlastInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_6: PBlast.TGetBlastInfoRequest = PBlast.TGetBlastInfoRequest.read(input);
                            _args.request = value_6;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new GetBlastInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetBlastInfoArgs from input");
            }
        }
    }
    export interface IRequestInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PBlast.TRequestInfoRequest;
    }
    export class RequestInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PBlast.TRequestInfoRequest;
        constructor(args: IRequestInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RequestInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RequestInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_7: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_7;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_8: PBlast.TRequestInfoRequest = PBlast.TRequestInfoRequest.read(input);
                            _args.request = value_8;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new RequestInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read RequestInfoArgs from input");
            }
        }
    }
    export interface ISubmitBlastResultArgs {
        success?: PBlast.TSubmitBlastResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        requestExpiredError?: GenericExceptions.TRequestExpired;
    }
    export class SubmitBlastResult {
        public success?: PBlast.TSubmitBlastResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public requestExpiredError?: GenericExceptions.TRequestExpired;
        constructor(args?: ISubmitBlastResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.requestExpiredError != null) {
                this.requestExpiredError = args.requestExpiredError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SubmitBlastResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.requestExpiredError != null) {
                output.writeFieldBegin("requestExpiredError", thrift.Thrift.Type.STRUCT, 2);
                this.requestExpiredError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SubmitBlastResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_9: PBlast.TSubmitBlastResponse = PBlast.TSubmitBlastResponse.read(input);
                            _args.success = value_9;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_10: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_10;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_11: GenericExceptions.TRequestExpired = GenericExceptions.TRequestExpired.read(input);
                            _args.requestExpiredError = value_11;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new SubmitBlastResult(_args);
        }
    }
    export interface IIsBlastEligibleResultArgs {
        success?: PBlast.TIsBlastEligibleResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class IsBlastEligibleResult {
        public success?: PBlast.TIsBlastEligibleResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IIsBlastEligibleResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("IsBlastEligibleResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): IsBlastEligibleResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_12: PBlast.TIsBlastEligibleResponse = PBlast.TIsBlastEligibleResponse.read(input);
                            _args.success = value_12;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_13: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_13;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_14: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_14;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new IsBlastEligibleResult(_args);
        }
    }
    export interface IUpdateBlastStatusResultArgs {
        success?: PBlast.TUpdateBlastStatusResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateBlastStatusResult {
        public success?: PBlast.TUpdateBlastStatusResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateBlastStatusResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateBlastStatusResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateBlastStatusResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_15: PBlast.TUpdateBlastStatusResponse = PBlast.TUpdateBlastStatusResponse.read(input);
                            _args.success = value_15;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_16: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_16;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_17: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_17;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateBlastStatusResult(_args);
        }
    }
    export interface IGetBlastInfoResultArgs {
        success?: PBlast.TGetBlastInfoResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        requestExpiredError?: GenericExceptions.TRequestExpired;
    }
    export class GetBlastInfoResult {
        public success?: PBlast.TGetBlastInfoResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public requestExpiredError?: GenericExceptions.TRequestExpired;
        constructor(args?: IGetBlastInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.requestExpiredError != null) {
                this.requestExpiredError = args.requestExpiredError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetBlastInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.requestExpiredError != null) {
                output.writeFieldBegin("requestExpiredError", thrift.Thrift.Type.STRUCT, 2);
                this.requestExpiredError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetBlastInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_18: PBlast.TGetBlastInfoResponse = PBlast.TGetBlastInfoResponse.read(input);
                            _args.success = value_18;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_19: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_19;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_20: GenericExceptions.TRequestExpired = GenericExceptions.TRequestExpired.read(input);
                            _args.requestExpiredError = value_20;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetBlastInfoResult(_args);
        }
    }
    export interface IRequestInfoResultArgs {
        success?: PBlast.TRequestInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class RequestInfoResult {
        public success?: PBlast.TRequestInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IRequestInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RequestInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RequestInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_21: PBlast.TRequestInfoResponse = PBlast.TRequestInfoResponse.read(input);
                            _args.success = value_21;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_22: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_22;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_23: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_23;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new RequestInfoResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public submitBlast(request: PBlast.TSubmitBlastRequest): Promise<PBlast.TSubmitBlastResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PBlast.TSubmitBlastResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_submitBlast(request, requestId);
            });
        }
        public isBlastEligible(header: PHeader.TAuthHeader, request: PBlast.TIsBlastEligibleRequest): Promise<PBlast.TIsBlastEligibleResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PBlast.TIsBlastEligibleResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_isBlastEligible(header, request, requestId);
            });
        }
        public updateBlastStatus(header: PHeader.TAuthHeader, request: PBlast.TUpdateBlastStatusRequest): Promise<PBlast.TUpdateBlastStatusResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PBlast.TUpdateBlastStatusResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateBlastStatus(header, request, requestId);
            });
        }
        public getBlastInfo(request: PBlast.TGetBlastInfoRequest): Promise<PBlast.TGetBlastInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PBlast.TGetBlastInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getBlastInfo(request, requestId);
            });
        }
        public requestInfo(header: PHeader.TAuthHeader, request: PBlast.TRequestInfoRequest): Promise<PBlast.TRequestInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PBlast.TRequestInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_requestInfo(header, request, requestId);
            });
        }
        public send_submitBlast(request: PBlast.TSubmitBlastRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("submitBlast", thrift.Thrift.MessageType.CALL, requestId);
            const args: SubmitBlastArgs = new SubmitBlastArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_isBlastEligible(header: PHeader.TAuthHeader, request: PBlast.TIsBlastEligibleRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("isBlastEligible", thrift.Thrift.MessageType.CALL, requestId);
            const args: IsBlastEligibleArgs = new IsBlastEligibleArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateBlastStatus(header: PHeader.TAuthHeader, request: PBlast.TUpdateBlastStatusRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateBlastStatus", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateBlastStatusArgs = new UpdateBlastStatusArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getBlastInfo(request: PBlast.TGetBlastInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getBlastInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetBlastInfoArgs = new GetBlastInfoArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_requestInfo(header: PHeader.TAuthHeader, request: PBlast.TRequestInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("requestInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: RequestInfoArgs = new RequestInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_submitBlast(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: SubmitBlastResult = SubmitBlastResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.requestExpiredError != null) {
                    return callback(result.requestExpiredError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "submitBlast failed: unknown result"));
                    }
                }
            }
        }
        public recv_isBlastEligible(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: IsBlastEligibleResult = IsBlastEligibleResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "isBlastEligible failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateBlastStatus(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateBlastStatusResult = UpdateBlastStatusResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateBlastStatus failed: unknown result"));
                    }
                }
            }
        }
        public recv_getBlastInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetBlastInfoResult = GetBlastInfoResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.requestExpiredError != null) {
                    return callback(result.requestExpiredError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getBlastInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_requestInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: RequestInfoResult = RequestInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "requestInfo failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        submitBlast(request: PBlast.TSubmitBlastRequest): PBlast.TSubmitBlastResponse | Promise<PBlast.TSubmitBlastResponse>;
        isBlastEligible(header: PHeader.TAuthHeader, request: PBlast.TIsBlastEligibleRequest): PBlast.TIsBlastEligibleResponse | Promise<PBlast.TIsBlastEligibleResponse>;
        updateBlastStatus(header: PHeader.TAuthHeader, request: PBlast.TUpdateBlastStatusRequest): PBlast.TUpdateBlastStatusResponse | Promise<PBlast.TUpdateBlastStatusResponse>;
        getBlastInfo(request: PBlast.TGetBlastInfoRequest): PBlast.TGetBlastInfoResponse | Promise<PBlast.TGetBlastInfoResponse>;
        requestInfo(header: PHeader.TAuthHeader, request: PBlast.TRequestInfoRequest): PBlast.TRequestInfoResponse | Promise<PBlast.TRequestInfoResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_submitBlast": {
                    this.process_submitBlast(requestId, input, output);
                    return;
                }
                case "process_isBlastEligible": {
                    this.process_isBlastEligible(requestId, input, output);
                    return;
                }
                case "process_updateBlastStatus": {
                    this.process_updateBlastStatus(requestId, input, output);
                    return;
                }
                case "process_getBlastInfo": {
                    this.process_getBlastInfo(requestId, input, output);
                    return;
                }
                case "process_requestInfo": {
                    this.process_requestInfo(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_submitBlast(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PBlast.TSubmitBlastResponse>((resolve, reject): void => {
                try {
                    const args: SubmitBlastArgs = SubmitBlastArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.submitBlast(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PBlast.TSubmitBlastResponse): void => {
                const result: SubmitBlastResult = new SubmitBlastResult({ success: data });
                output.writeMessageBegin("submitBlast", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: SubmitBlastResult = new SubmitBlastResult({ invalidRequestError: err });
                    output.writeMessageBegin("submitBlast", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TRequestExpired) {
                    const result: SubmitBlastResult = new SubmitBlastResult({ requestExpiredError: err });
                    output.writeMessageBegin("submitBlast", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("submitBlast", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_isBlastEligible(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PBlast.TIsBlastEligibleResponse>((resolve, reject): void => {
                try {
                    const args: IsBlastEligibleArgs = IsBlastEligibleArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.isBlastEligible(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PBlast.TIsBlastEligibleResponse): void => {
                const result: IsBlastEligibleResult = new IsBlastEligibleResult({ success: data });
                output.writeMessageBegin("isBlastEligible", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: IsBlastEligibleResult = new IsBlastEligibleResult({ authFailedError: err });
                    output.writeMessageBegin("isBlastEligible", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: IsBlastEligibleResult = new IsBlastEligibleResult({ invalidRequestError: err });
                    output.writeMessageBegin("isBlastEligible", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("isBlastEligible", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateBlastStatus(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PBlast.TUpdateBlastStatusResponse>((resolve, reject): void => {
                try {
                    const args: UpdateBlastStatusArgs = UpdateBlastStatusArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateBlastStatus(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PBlast.TUpdateBlastStatusResponse): void => {
                const result: UpdateBlastStatusResult = new UpdateBlastStatusResult({ success: data });
                output.writeMessageBegin("updateBlastStatus", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateBlastStatusResult = new UpdateBlastStatusResult({ authFailedError: err });
                    output.writeMessageBegin("updateBlastStatus", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateBlastStatusResult = new UpdateBlastStatusResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateBlastStatus", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateBlastStatus", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getBlastInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PBlast.TGetBlastInfoResponse>((resolve, reject): void => {
                try {
                    const args: GetBlastInfoArgs = GetBlastInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getBlastInfo(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PBlast.TGetBlastInfoResponse): void => {
                const result: GetBlastInfoResult = new GetBlastInfoResult({ success: data });
                output.writeMessageBegin("getBlastInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetBlastInfoResult = new GetBlastInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("getBlastInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TRequestExpired) {
                    const result: GetBlastInfoResult = new GetBlastInfoResult({ requestExpiredError: err });
                    output.writeMessageBegin("getBlastInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getBlastInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_requestInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PBlast.TRequestInfoResponse>((resolve, reject): void => {
                try {
                    const args: RequestInfoArgs = RequestInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.requestInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PBlast.TRequestInfoResponse): void => {
                const result: RequestInfoResult = new RequestInfoResult({ success: data });
                output.writeMessageBegin("requestInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: RequestInfoResult = new RequestInfoResult({ authFailedError: err });
                    output.writeMessageBegin("requestInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: RequestInfoResult = new RequestInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("requestInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("requestInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
export interface ITSubmitBlastRequestArgs {
    userSlug: string;
    requestId: string;
    token: string;
    timestampSec: number | Int64;
    contact: PContact.TAppContact;
    personaList: Array<PContact.TAppPersona>;
}
export class TSubmitBlastRequest {
    public userSlug: string;
    public requestId: string;
    public token: string;
    public timestampSec: Int64;
    public contact: PContact.TAppContact;
    public personaList: Array<PContact.TAppPersona>;
    constructor(args: ITSubmitBlastRequestArgs) {
        if (args != null && args.userSlug != null) {
            this.userSlug = args.userSlug;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userSlug] is unset!");
        }
        if (args != null && args.requestId != null) {
            this.requestId = args.requestId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[requestId] is unset!");
        }
        if (args != null && args.token != null) {
            this.token = args.token;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[token] is unset!");
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestampSec] is unset!");
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.personaList != null) {
            this.personaList = args.personaList;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[personaList] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSubmitBlastRequest");
        if (this.userSlug != null) {
            output.writeFieldBegin("userSlug", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userSlug);
            output.writeFieldEnd();
        }
        if (this.requestId != null) {
            output.writeFieldBegin("requestId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.requestId);
            output.writeFieldEnd();
        }
        if (this.token != null) {
            output.writeFieldBegin("token", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.token);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 5);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.personaList != null) {
            output.writeFieldBegin("personaList", thrift.Thrift.Type.LIST, 6);
            output.writeListBegin(thrift.Thrift.Type.I32, this.personaList.length);
            this.personaList.forEach((value_24: PContact.TAppPersona): void => {
                output.writeI32(value_24);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSubmitBlastRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_25: string = input.readString();
                        _args.userSlug = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_26: string = input.readString();
                        _args.requestId = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_27: string = input.readString();
                        _args.token = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_28: Int64 = input.readI64();
                        _args.timestampSec = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_29: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_29;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_30: Array<PContact.TAppPersona> = new Array<PContact.TAppPersona>();
                        const metadata_1: thrift.TList = input.readListBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_31: PContact.TAppPersona = input.readI32();
                            value_30.push(value_31);
                        }
                        input.readListEnd();
                        _args.personaList = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userSlug !== undefined && _args.requestId !== undefined && _args.token !== undefined && _args.timestampSec !== undefined && _args.contact !== undefined && _args.personaList !== undefined) {
            return new TSubmitBlastRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSubmitBlastRequest from input");
        }
    }
}
export interface ITSubmitBlastResponseArgs {
    success: boolean;
}
export class TSubmitBlastResponse {
    public success: boolean;
    constructor(args: ITSubmitBlastResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSubmitBlastResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSubmitBlastResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_32: boolean = input.readBool();
                        _args.success = value_32;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TSubmitBlastResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSubmitBlastResponse from input");
        }
    }
}
export interface ITUpdateBlastStatusRequestArgs {
    userId: string;
    start: boolean;
}
export class TUpdateBlastStatusRequest {
    public userId: string;
    public start: boolean;
    constructor(args: ITUpdateBlastStatusRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.start != null) {
            this.start = args.start;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[start] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateBlastStatusRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.start != null) {
            output.writeFieldBegin("start", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.start);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateBlastStatusRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_33: string = input.readString();
                        _args.userId = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_34: boolean = input.readBool();
                        _args.start = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.start !== undefined) {
            return new TUpdateBlastStatusRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateBlastStatusRequest from input");
        }
    }
}
export interface ITUpdateBlastStatusResponseArgs {
    blastId: string;
    started: boolean;
}
export class TUpdateBlastStatusResponse {
    public blastId: string;
    public started: boolean;
    constructor(args: ITUpdateBlastStatusResponseArgs) {
        if (args != null && args.blastId != null) {
            this.blastId = args.blastId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[blastId] is unset!");
        }
        if (args != null && args.started != null) {
            this.started = args.started;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[started] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateBlastStatusResponse");
        if (this.blastId != null) {
            output.writeFieldBegin("blastId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.blastId);
            output.writeFieldEnd();
        }
        if (this.started != null) {
            output.writeFieldBegin("started", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.started);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateBlastStatusResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_35: string = input.readString();
                        _args.blastId = value_35;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_36: boolean = input.readBool();
                        _args.started = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.blastId !== undefined && _args.started !== undefined) {
            return new TUpdateBlastStatusResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateBlastStatusResponse from input");
        }
    }
}
export interface ITIsBlastEligibleRequestArgs {
    userId: string;
}
export class TIsBlastEligibleRequest {
    public userId: string;
    constructor(args: ITIsBlastEligibleRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TIsBlastEligibleRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TIsBlastEligibleRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_37: string = input.readString();
                        _args.userId = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined) {
            return new TIsBlastEligibleRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TIsBlastEligibleRequest from input");
        }
    }
}
export interface ITIsBlastEligibleResponseArgs {
    eligible: boolean;
    isPaused: boolean;
}
export class TIsBlastEligibleResponse {
    public eligible: boolean;
    public isPaused: boolean;
    constructor(args: ITIsBlastEligibleResponseArgs) {
        if (args != null && args.eligible != null) {
            this.eligible = args.eligible;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[eligible] is unset!");
        }
        if (args != null && args.isPaused != null) {
            this.isPaused = args.isPaused;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isPaused] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TIsBlastEligibleResponse");
        if (this.eligible != null) {
            output.writeFieldBegin("eligible", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.eligible);
            output.writeFieldEnd();
        }
        if (this.isPaused != null) {
            output.writeFieldBegin("isPaused", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.isPaused);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TIsBlastEligibleResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_38: boolean = input.readBool();
                        _args.eligible = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_39: boolean = input.readBool();
                        _args.isPaused = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.eligible !== undefined && _args.isPaused !== undefined) {
            return new TIsBlastEligibleResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TIsBlastEligibleResponse from input");
        }
    }
}
export interface ITGetBlastInfoRequestArgs {
    userSlug: string;
    requestId: string;
    token: string;
    timestampSec: number | Int64;
}
export class TGetBlastInfoRequest {
    public userSlug: string;
    public requestId: string;
    public token: string;
    public timestampSec: Int64;
    constructor(args: ITGetBlastInfoRequestArgs) {
        if (args != null && args.userSlug != null) {
            this.userSlug = args.userSlug;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userSlug] is unset!");
        }
        if (args != null && args.requestId != null) {
            this.requestId = args.requestId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[requestId] is unset!");
        }
        if (args != null && args.token != null) {
            this.token = args.token;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[token] is unset!");
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestampSec] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetBlastInfoRequest");
        if (this.userSlug != null) {
            output.writeFieldBegin("userSlug", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userSlug);
            output.writeFieldEnd();
        }
        if (this.requestId != null) {
            output.writeFieldBegin("requestId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.requestId);
            output.writeFieldEnd();
        }
        if (this.token != null) {
            output.writeFieldBegin("token", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.token);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetBlastInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_40: string = input.readString();
                        _args.userSlug = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_41: string = input.readString();
                        _args.requestId = value_41;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_42: string = input.readString();
                        _args.token = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_43: Int64 = input.readI64();
                        _args.timestampSec = value_43;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userSlug !== undefined && _args.requestId !== undefined && _args.token !== undefined && _args.timestampSec !== undefined) {
            return new TGetBlastInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetBlastInfoRequest from input");
        }
    }
}
export interface ITGetBlastInfoResponseArgs {
    requester: PContact.TAppContact;
    contactInfo?: PContact.TAppContact;
}
export class TGetBlastInfoResponse {
    public requester: PContact.TAppContact;
    public contactInfo?: PContact.TAppContact;
    constructor(args: ITGetBlastInfoResponseArgs) {
        if (args != null && args.requester != null) {
            this.requester = args.requester;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[requester] is unset!");
        }
        if (args != null && args.contactInfo != null) {
            this.contactInfo = args.contactInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetBlastInfoResponse");
        if (this.requester != null) {
            output.writeFieldBegin("requester", thrift.Thrift.Type.STRUCT, 1);
            this.requester.write(output);
            output.writeFieldEnd();
        }
        if (this.contactInfo != null) {
            output.writeFieldBegin("contactInfo", thrift.Thrift.Type.STRUCT, 2);
            this.contactInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetBlastInfoResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_44: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.requester = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_45: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contactInfo = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.requester !== undefined) {
            return new TGetBlastInfoResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetBlastInfoResponse from input");
        }
    }
}
export interface ITRequestInfoRequestArgs {
    contactId: string;
}
export class TRequestInfoRequest {
    public contactId: string;
    constructor(args: ITRequestInfoRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRequestInfoRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRequestInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_46: string = input.readString();
                        _args.contactId = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TRequestInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRequestInfoRequest from input");
        }
    }
}
export interface ITRequestInfoResponseArgs {
}
export class TRequestInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRequestInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRequestInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TRequestInfoResponse();
    }
}
